import { render, staticRenderFns } from "./BeatCircle.vue?vue&type=template&id=d056490c&scoped=true&lang=html&"
import script from "./BeatCircle.vue?vue&type=script&lang=js&"
export * from "./BeatCircle.vue?vue&type=script&lang=js&"
import style0 from "./BeatCircle.vue?vue&type=style&index=0&id=d056490c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d056490c",
  null
  
)

export default component.exports